import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import IconButton from '@shared/ui/molecules/icon-button/IconButton';
import { SimpleSpinner } from '@shared/ui/atoms/SimpleSpinner';
import { UserAvatarAndName } from '@shared/ui/molecules/UserAvatarAndName';
import { useDispatch } from 'react-redux';
import { failureNotification, successNotification } from '@shared/store/notification.duck';
import { removeUserTagRequest } from '@shared/services/Tags';
import { BasicUserInfo } from '@shared/models/user.models';

interface Props {
  user: BasicUserInfo;
  workGroupId: number;
  canRemove: boolean;
  onRemoved: (userId: string) => void;
}

export function WorkGroupMemberRow(props: Props) {
  const dispatch = useDispatch();
  const [removing, setRemoving] = useState(false);

  const onRemove = async () => {
    if (removing) return;
    setRemoving(true);
    try {
      await removeUserTagRequest(props.user.userId, props.workGroupId);
      dispatch(successNotification('User removed from workgroup'));
      props.onRemoved(props.user.userId);
    } catch {
      dispatch(failureNotification('Failed to remove user from workgroup'));
      setRemoving(false);
    }
  };

  return (
    <Row>
      <Link to={`/manage/user/${props.user.userId}`} className="noDecoration">
        <UserAvatarAndName colour="blue" firstName={props.user.firstName} lastName={props.user.lastName} />
      </Link>
      {props.canRemove && (
        removing
          ? <SimpleSpinner size={20} />
          : <IconButton icon={IconTypes.Close}
                        color="darkGrey"
                        dataTest="workGroupMember-remove"
                        onClick={onRemove} />
      )}
    </Row>
  );
}

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
`;
